import { INfcCardsContext } from './nfcCardsContext';

export enum NfcCardsActionsTypes {
	REFETCH_DATA = 'REFETCH_DATA',
	SET_INITIAL_NFC_CARDS = 'SET_INITIAL_NFC_CARDS',
	SET_NFC_CARDS = 'SET_NFC_CARDS',
	SET_DATA_FOR_SUBMIT = 'SET_DATA_FOR_SUBMIT',
	CHANGE_TYPE_OF_MODAL_WINDOW = 'CHANGE_TYPE_OF_MODAL_WINDOW',
}

interface IRefetchData {
	type: NfcCardsActionsTypes.REFETCH_DATA;
	payload: {
		needRefetchData: INfcCardsContext['needRefetchData'];
	};
}

interface ISetInitialNfcCards {
	type: NfcCardsActionsTypes.SET_INITIAL_NFC_CARDS;
	payload: {
		initialNfcCards: INfcCardsContext['initialNfcCards'];
		nfcCards: INfcCardsContext['nfcCards'];
	};
}

interface ISetNfcCards {
	type: NfcCardsActionsTypes.SET_NFC_CARDS;
	payload: {
		nfcCards: INfcCardsContext['nfcCards'];
	};
}

interface ISetDataForSubmit {
	type: NfcCardsActionsTypes.SET_DATA_FOR_SUBMIT;
	payload: {
		dataForSubmit: INfcCardsContext['dataForSubmit'];
	};
}

interface IChangeTypeOfModalWindow {
	type: NfcCardsActionsTypes.CHANGE_TYPE_OF_MODAL_WINDOW;
	payload: {
		typeOfModalWindow: INfcCardsContext['typeOfModalWindow'];
	};
}

export type TNfcCardsAction =
	| IRefetchData
	| ISetInitialNfcCards
	| ISetNfcCards
	| ISetDataForSubmit
	| IChangeTypeOfModalWindow;
